export * from "./chain";
export * from "./fromStatic";
export * from "./memoize";
export * from "./ProviderError";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxTQUFTLENBQUM7QUFDeEIsY0FBYyxjQUFjLENBQUM7QUFDN0IsY0FBYyxXQUFXLENBQUM7QUFDMUIsY0FBYyxpQkFBaUIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL2NoYWluXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9mcm9tU3RhdGljXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9tZW1vaXplXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9Qcm92aWRlckVycm9yXCI7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@aws-sdk/property-provider/dist/es/index.js
// module id = 865
// module chunks = 0